export const eventPropertyCountMap = {
    "AutoAccountLinkedEvent": 0,
    "AdsVideoAudioRollClickedEvent": 9,
    "AdsVideoAudioRollCompletedEvent": 9,
    "UpdateDownloadFailedEvent": 1,
    "AutoUiSearchResultFailedEvent": 2,
    "AdsPlaybackResumedEvent": 11,
    "AdsDisplayCertifiedImpressionEvent": 14,
    "AdsDisplayRequestFailedEvent": 9,
    "PrebufferPrerollResponseReceivedEvent": 5,
    "AdsPlaybackStartedEvent": 14,
    "AutoUiSearchResultLoadedEvent": 0,
    "AdsVideoAudioRollRequestFailedEvent": 10,
    "PrebufferPrerollRequestedEvent": 4,
    "AdsDisplayClickedEvent": 7,
    "AdsBiddingRequestFailedEvent": 10,
    "PrebufferStreamCancelledEvent": 4,
    "AccountDeletionRequestFailedEvent": 2,
    "DiscordUserLeftEvent": 3,
    "AdsDisplayRequestedEvent": 9,
    "UpdateInstallationStartedEvent": 0,
    "PrebufferPrerollStartedEvent": 6,
    "UpdateAvailableEvent": 0,
    "DiscordOauthAcceptedEvent": 1,
    "AutoLocationConsentShownEvent": 0,
    "AdsVideoAudioRollResponseReceivedEvent": 9,
    "PrebufferStreamFailedEvent": 4,
    "PrebufferPrerollSuccessEvent": 7,
    "DiscordOauthDeniedEvent": 3,
    "SandboxEvent": 3,
    "PrebufferStreamEligibilityDecidedEvent": 2,
    "AdsDisplayClosedEvent": 4,
    "AdsPlaybackFailedEvent": 17,
    "AdsDisplayViewabilityStatusEvent": 7,
    "DiscordActivityEndedEvent": 2,
    "AdsDisplayResponseReceivedEvent": 8,
    "AppAccessTokenRefreshFailedEvent": 3,
    "AccountDeletionRequestedEvent": 0,
    "DiscordUserJoinedEvent": 2,
    "UpdateDownloadSuccessEvent": 0,
    "PrebufferPrerollTimeoutEvent": 3,
    "AutoLocationPermissionGrantedEvent": 0,
    "AutoAppInitiatedEvent": 0,
    "PrebufferConnectionLostPlaybackContinuesEvent": 1,
    "AdsPlaybackCancelledEvent": 11,
    "PrebufferTimeEndedEvent": 0,
    "UpdateDownloadStartedEvent": 0,
    "DiscordSharedModeDeactivatedEvent": 2,
    "AdsBiddingResponseReceivedEvent": 6,
    "AutoRegistrationSessionExpiredEvent": 3,
    "AdsInstreamStartedEvent": 6,
    "AutoUiSessionDestroyedEvent": 0,
    "AutoUiRootFailedEvent": 2,
    "AutoUiCategoryFailedEvent": 4,
    "AutoUiServiceConnectionSuspendedEvent": 0,
    "AdsVideoAudioRollEligibilityDecidedEvent": 6,
    "AdsVideoAudioRollRequestedEvent": 11,
    "PrebufferStreamStartedEvent": 1,
    "PrebufferStreamTimeoutEvent": 1,
    "AutoUiServiceConnectionFailedEvent": 0,
    "AutoRegistrationShownEvent": 0,
    "PrebufferPrerollFailedEvent": 9,
    "AdsBiddingRequestedEvent": 6,
    "AdsInstreamCompletedEvent": 5,
    "DiscordSharedModeActivatedEvent": 2,
    "AdsDisplayRequestCancelledEvent": 6,
    "PrebufferPrerollRequestFailedEvent": 4,
    "PrebufferPrerollEligibilityDecidedEvent": 4,
    "AdsInstreamReceivedEvent": 5,
    "PrebufferUserWentLiveEvent": 0,
    "AutoContentRequestFailedEvent": 4,
    "DiscordHostAssignedEvent": 2,
    "ApplicationSessionStartedEvent": 0,
    "PrebufferUserFastForwardedEvent": 0,
    "AutoUiServiceConnectedEvent": 0,
    "AutoRegistrationPinCodeShownEvent": 0,
    "AutoSubscriptionDataRequestFailedEvent": 3,
    "AutoLocationConsentSkippedEvent": 0,
    "PrebufferUserRewoundEvent": 0,
    "AdsInstreamQuartileStatusEvent": 6,
    "PrebufferPrerollCancelledEvent": 6,
    "AdsPlaybackPausedEvent": 12,
    "AccountDeletionRegisteredEvent": 0,
    "AutoAppFirstOpenEvent": 0,
    "ContentClickedEvent": 12,
    "ContentImpressionEvent": 11,
    "AutoEmptyPageReturnedEvent": 1,
    "AutoHomePageLoadedEvent": 0,
    "DiscordMaxParticipantsReachedEvent": 2,
    "PrebufferStreamSuccessEvent": 2,
    "AdsDisplayImpressionEvent": 8,
    "UserPlayClickedEvent": 4,
    "DiscordActivityInitiatedEvent": 4,
    "AutoUiRootLoadedEvent": 0,
    "AutoLocationPermissionDeniedEvent": 0,
    "AutoRegistrationDataRequestFailedEvent": 3,
    "AdsPlaybackFinishedEvent": 15,
    "AutoUiCategoryLoadedEvent": 2,
    "ListenSessionStartedEvent": 6
};
